import "./Sidebar.css";
import React, { useState, useEffect, useRef, useMemo } from 'react';

import { Link, NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../components/Images/flicklogo.png";
import add_list_01 from "../../components/Images/sidebar_icon/add_list_01.svg";
import Ads_Categories_01 from "../../components/Images/sidebar_icon/Ads_Categories_01.svg";
import Ads_Compaigns_01 from "../../components/Images/sidebar_icon/Ads_Compaigns_01.svg";
import Ads_Plans_01 from "../../components/Images/sidebar_icon/Ads_Plans_01.svg";
import ads_revenue_01 from "../../components/Images/sidebar_icon/ads_revenue_01.svg";
import ads_time_slot_01 from "../../components/Images/sidebar_icon/ads_time_slot_01.svg";
import analytics_01 from "../../components/Images/sidebar_icon/analytics_01.svg";
import Artist_Management_01 from "../../components/Images/sidebar_icon/Artist_Management_01.svg";
import Audio_Management_01 from "../../components/Images/sidebar_icon/Audio_Management_01.svg";
import Cache_Management_01 from "../../components/Images/sidebar_icon/Cache_Management_01.svg";
import Calender_Events_01 from "../../components/Images/sidebar_icon/Calender_Events_01.svg";
import channel_partner_01 from "../../components/Images/sidebar_icon/channel_partner_01.svg";
import content_partner_01 from "../../components/Images/sidebar_icon/content_partner_01.svg";
import Dashboard_01 from "../../components/Images/sidebar_icon/Dashboard_01.svg";
import debug_01 from "../../components/Images/sidebar_icon/debug_01.svg";
// import File_Manager_01 from "../../components/Images/sidebar_icon/File_Manager_01.svg";
import Language_01 from "../../components/Images/sidebar_icon/Language_01.svg";
import Email_Settings from "../../components/Images/sidebar_icon/Email_Settings.svg";
import Manage_Advertiser_01 from "../../components/Images/sidebar_icon/Manage_Advertiser_01.svg";
import Manage_LiveStream_01 from "../../components/Images/sidebar_icon/Manage_LiveStream_01.svg";
import Menu_01 from "../../components/Images/sidebar_icon/Menu_01.svg";
import Pages_01 from "../../components/Images/sidebar_icon/Pages_01.svg";
import Payment_Management_01 from "../../components/Images/sidebar_icon/Payment_Management_01.svg";
import plans_01 from "../../components/Images/sidebar_icon/plans_01.svg";
import Player_ui_01 from "../../components/Images/sidebar_icon/Player_ui_01.svg";
import See_Log_Activity_01 from "../../components/Images/sidebar_icon/See_Log_Activity_01.svg";
import Series_Episode_01 from "../../components/Images/sidebar_icon/Series_Episode_01.svg";
import Settings_01 from "../../components/Images/sidebar_icon/Settings_01.svg";
import slider_01 from "../../components/Images/sidebar_icon/slider_01.svg";
import user_01 from "../../components/Images/sidebar_icon/user_01.svg";
import Video_Management_01 from "../../components/Images/sidebar_icon/Video_Management_01.svg";
import contact_request from "../../components/Images/sidebar_icon/contact_request.svg";
import { useTranslation } from 'react-i18next';
import MessageBox from "../../components/CommonComponents/MessageBox";
import { IoIosArrowDown, IoMdClose } from "react-icons/io";
import axios from "axios"
import NavigationData from "./NavigationData";
import loadings from "../../../src/components/Images/loading/gif_loadings.gif";
import Defaultloadinggif from "../Others/Defaultloadinggif";
import getMenuDatalabel from "../Others/Labelmenuapi";
import Response_Processing from "../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../components/Provider/CommonProvider";
import { connect } from "react-redux";
import { IconMyAudio } from "../../Assets/MyIcons";
import CustomTooltip from "../../components/CustomTooltip/SidebarTooltip";
import { getBannerInfo } from '../../component/Commonmethod/bannerUtils';

function Sidebar({ toggleClassName, toggleAction, labelDisplay, onlyPermission, adminSetting, siteTheme, loading }) {

    const { isExpired, getExpiryMessage, fetchRequest, accessToken } = useMyContext()

    const { superAdminURL, artistURL, audioURL, faqURL, liveURL, userURL, menuURL, menuURLRegistrationMenu, videoURL, seriesURL, languageURL, regionURL, contentPartnerURL, channelPartnerURL, pagesURL, plansURL, paymentURL, donationURL, analyticsURL, settingsURL, settingsURLhome, settingsURLApp, PartnerURL, RolesURL, PartnerPayout, LibraryURL, radioStationURL, importExportURL, Partner_payoutURL, playerUrl, translationURL, partnerSettingsURL, imageOrientationURL, advertiserMenuUrls, pushNotificationURL, PartnerAnalyticsURL } = NavigationData(labelDisplay);
    const [customFieldsEnabled, setCustomFieldsEnabled] = useState(false);
    const role = localStorage.getItem("role");

    const fetchPlugins = async () => {
        try {
            const resp = await fetchRequest({ method: 'GET', url: `${process.env.REACT_APP_Baseurl}/admin/plugins/status` })
            const cf = (resp?.data?.plugins || []).find(p => p.id === 'custom_fields');
            setCustomFieldsEnabled(!!cf?.enabled);
        } catch (e) {
            setCustomFieldsEnabled(false);
        }
    };

    useEffect(() => {
        fetchPlugins()
    }, []);

    const isSubscriptionExpired = isExpired();
    const allowedRoutes = ["/", "/purchase-subscription"];

    const handleBlockedNav = (e) => {
        if (!isSubscriptionExpired) return;
        const anchor = e.target?.closest && e.target.closest('a');
        if (anchor) {
            const href = anchor.getAttribute("href");
            if (allowedRoutes.includes(href)) return;
            e.preventDefault();
            e.stopPropagation();
            toast.error(getExpiryMessage());
        }
    };
    const handleKeyBlock = (e) => {
        if (!isSubscriptionExpired) return;
        const isActivateKey = e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
        if (!isActivateKey) return;
        const anchor = e.target?.closest && e.target.closest('a');
        if (anchor) {
            const href = anchor.getAttribute("href");
            if (allowedRoutes.includes(href)) return;
            e.preventDefault();
            e.stopPropagation();
            toast.error(getExpiryMessage());
        }
    };

    const tooltipConfig = {
        message: "Upgrade the plan and access the full features",
        position: 'right',
        theme: 'warning',
        interactive: true,
        showActionButton: true,
        actionButtonText: "Upgrade Plan",
        actionButtonUrl: "/purchase-subscription"
    }

    const DashboardManagementMenu = () => (
        <li className="nav-item mb-4">
            <NavLink to={"/"} className="d-flex align-items-center sideMenu position-relative"  >
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <rect class="cls-1" style={{ fill: "none", stroke: "currentcolor", strokeMiterlimit: "10", strokeWidth: "0.75pxa" }} x="1" y="1.16" width="10.11" height="7.14" rx="0.89" />
                            <rect class="cls-1" style={{ fill: "none", stroke: "currentcolor", strokeMiterlimit: "10", strokeWidth: "0.75pxa" }} x="12.89" y="16.02" width="10.11" height="7.14" rx="0.89" />
                            <rect class="cls-1" style={{ fill: "none", stroke: "currentcolor", strokeMiterlimit: "10", strokeWidth: "0.75pxa" }} x="1" y="10.67" width="10.11" height="12.49" rx="1.18" />
                            <rect class="cls-1" style={{ fill: "none", stroke: "currentcolor", strokeMiterlimit: "10", strokeWidth: "0.75pxa" }} x="12.89" y="1.16" width="10.11" height="12.49" rx="1.18" />
                        </g>
                    </svg>
                </div>
                <MessageBox text={labelDisplay?.[0]?.title} classname="ms-2 text-break" />
            </NavLink>
        </li>
    );

    const SuperAdminManagementMenu = () => (
        Number(role) === 5 && onlyPermission?.includes(36) &&
        <li className="nav-item mb-4">
            <MessageBox text={`Super Admin Management `} classname='sideBarHeading d-block w-100 theme-text-color px-3 pb-2 text-start d-block' />
            <div id="SuperAdminManagement" className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative  px-3  mb-2 ${(window.location.pathname.startsWith('/playout-settings') || window.location.pathname.startsWith('/product-type-settings') || window.location.pathname.startsWith('/library-setting') || window.location.pathname.startsWith('/payment-gateways-settings') || window.location.pathname.startsWith('/storage_settings')) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Super-Admin" aria-expanded="false" aria-controls="Super-Admin"  >
                <img src={Settings_01} alt="flogo" className="" />
                <MessageBox text={`Super Admin Settings`} classname="ms-2 text-break" />
                <IoIosArrowDown />
            </div>
            <ul id="Super-Admin" className={`collapse p-0 mt-2 list-unstyled ${(window.location.pathname.startsWith('/playout-settings') || window.location.pathname.startsWith('/product-type-settings') || window.location.pathname.startsWith('/library-setting') || window.location.pathname.startsWith('/payment-gateways-settings') || window.location.pathname.startsWith('/storage_settings')) && 'show'}`} >
                {superAdminURL?.sort((a, b) => a.message.localeCompare(b.message))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                            <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                        </NavLink>
                    </li>
                ))}
            </ul>
        </li>
    );

    const RolesAndPermissionManagementMenu = () => (
        Number(role) === 5 && onlyPermission?.includes(26) &&
        <li className="nav-item mb-4" >
            <MessageBox text={'Role Management'} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' />
            <div className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative mb-2 px-3 ${RolesURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Roles" aria-expanded="false" aria-controls="Roles"  >
                <div>
                    <img src={channel_partner_01} alt="flogo" className="" />
                    <MessageBox text={'Roles'} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Roles" className={`collapse p-0 mt-2 list-unstyled  ${RolesURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}`} >
                {RolesURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => <li className=" mb-2" >
                    <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4  pe-3">
                        <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                    </NavLink>
                </li>)}
            </ul>
        </li>
    );

    const LibraryManagementMenu = () => (
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[148]?.title} classname='sideBarHeading d-block w-100 theme-text-color px-3 pb-2 text-start d-block' crown={!onlyPermission?.includes(27)} />
            <div id="libraryManagement" className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative  px-3  mb-2 ${(window.location.pathname.startsWith('/add-library') || window.location.pathname.includes('/library')) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Library-Management" aria-expanded="false" aria-controls="Library-Management"  >
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <rect class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x="1" y="3.16" width="22.01" height="12.89" rx="0.94" /> <g>
                                <line class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="22.78" y1="20.82" x2="13.33" y2="20.82" />
                                <line class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="10.67" y1="20.82" x2="1.22" y2="20.82" />
                                <path class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M13.33,20.82a1.33,1.33,0,1,0-2.66,0" />
                                <path class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M10.67,20.82a1.33,1.33,0,1,0,2.66,0" />
                            </g>
                            <polygon class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} points="9.9 12.2 9.9 6.54 14.1 9.37 9.9 12.2" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[149]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Library-Management" className={`collapse p-0 mt-2 list-unstyled ${(window.location.pathname.startsWith('/add-library') || window.location.pathname.startsWith('/library')) && 'show'}`} >
                {LibraryURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(27) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const VideoManagementMenu = () => (
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[3]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(3)} />
            <div id="videoManagement" className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative  px-3  mb-2 ${(window.location.pathname.startsWith('/add-video') || window.location.pathname.startsWith('/video-for-approval') || window.location.pathname.startsWith('/allplaylist') || window.location.pathname.startsWith('/video-categories') || window.location.pathname.startsWith('/video-schedule') || window.location.pathname.startsWith('/video-lists')) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Video-Management" aria-expanded="false" aria-controls="Video-Management"  >
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <rect class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x="1" y="3.16" width="22.01" height="12.89" rx="0.94" /> <g>
                                <line class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="22.78" y1="20.82" x2="13.33" y2="20.82" />
                                <line class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="10.67" y1="20.82" x2="1.22" y2="20.82" />
                                <path class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M13.33,20.82a1.33,1.33,0,1,0-2.66,0" />
                                <path class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M10.67,20.82a1.33,1.33,0,1,0,2.66,0" />
                            </g>
                            <polygon class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} points="9.9 12.2 9.9 6.54 14.1 9.37 9.9 12.2" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[4]?.title} classname="ms-2 text-break" />
                </div>

                <IoIosArrowDown />
            </div>
            <ul id="Video-Management" className={`collapse p-0 mt-2 list-unstyled ${(window.location.pathname.startsWith('/add-video') || window.location.pathname.startsWith('/video-for-approval') || window.location.pathname.startsWith('/allplaylist') || window.location.pathname.startsWith('/video-categories') || window.location.pathname.startsWith('/video-schedule') || window.location.pathname.startsWith('/video-lists')) && 'show'}`} >
                {videoURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(3) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const UGCManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={'UGC Management'} crown={!onlyPermission?.includes(39)} classname='text-start sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' />
            <div className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative mb-2 px-3  ${audioURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle={"collapse"} data-bs-target={"#UGC-Management"} aria-expanded="false" aria-controls="UGC-Management">
                <div>
                    <img src={user_01} alt="flogo" />
                    <MessageBox text={'UGC'} classname="ms-2 text-break" premium={!onlyPermission?.includes(39)} />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="UGC-Management" className={`collapse p-0 mt-2 list-unstyled  ${(window.location.pathname.startsWith('/ugc-list')) && 'show'}`}>
                <li className="mb-2">
                    {onlyPermission?.includes(39) ? (
                        <NavLink to="/ugc-list" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"                                    >
                            <MessageBox text="UGC List" classname="ms-2 text-break" />
                        </NavLink>
                    ) : (
                        <CustomTooltip {...tooltipConfig} >
                            <MessageBox text="UGC List" classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                        </CustomTooltip>
                    )}
                </li>
            </ul>
        </li>
    );

    const SeriesManagementMenu = () => (
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[150]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(4)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative px-3  ${(window.location.pathname.startsWith('/series-list') || window.location.pathname.startsWith('/add-series') || window.location.pathname.startsWith('/series-category')) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Series-Episode" aria-expanded="false" aria-controls="Series-Episode">
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <g>
                                <rect class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x="0.81" y="1" width="22.38" height="19.02" rx="4.08" />
                                <line class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="1.12" y1="15.38" x2="23.17" y2="15.38" />
                                <line class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="9.63" y1="20.16" x2="8.98" y2="22.8" />
                                <line class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="14.44" y1="20.16" x2="14.92" y2="22.8" />
                                <line class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="6.71" y1="23.31" x2="17.36" y2="23.31" />
                            </g>
                            <polygon class="cls-1" points="10.2 11.5 10.2 5.49 15.02 8.43 10.2 11.5" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[14]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Series-Episode" className={`collapse p-0 mt-2 list-unstyled  ${(window.location.pathname.startsWith('/series-list') || window.location.pathname.startsWith('/add-series') || window.location.pathname.startsWith('/series-category')) && 'show'}  `}>
                {seriesURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(4) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const LiveStreamManagementMenu = () => (
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[21]?.title} classname='text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block' crown={!onlyPermission?.includes(5)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3   ${liveURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'} `} data-bs-toggle="collapse" data-bs-target="#Live-Stream" aria-expanded="false" aria-controls="Live-Stream">
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <g>
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M19.29,3.57A11.21,11.21,0,0,1,23,9.83a10.82,10.82,0,0,1,.25,2.34,11.24,11.24,0,0,1-4,8.57" />
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M16.53,6.94a6.93,6.93,0,0,1,0,10.48" />
                            </g>
                            <g>
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M4.71,3.57A11.21,11.21,0,0,0,1,9.83a10.82,10.82,0,0,0-.25,2.34,11.24,11.24,0,0,0,4,8.57" />
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M7.47,6.94a6.93,6.93,0,0,0,0,10.48" />
                            </g>
                            <circle cx="12.13" cy="12.16" r="1.37" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[22]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Live-Stream" className={`collapse p-0 mt-2 list-unstyled ${liveURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {liveURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(5) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const RadioStationManagementMenu = () => (
        Number(siteTheme?.radiostation_active) === 1 &&
        <li className="nav-item mb-4">
            <MessageBox text="Radio Station" classname="text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block" crown={!onlyPermission?.includes(40)} />

            <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 ${radioStationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#radio-station" aria-expanded="false" aria-controls="radio-station" >
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <g>
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M19.29,3.57A11.21,11.21,0,0,1,23,9.83a10.82,10.82,0,0,1,.25,2.34,11.24,11.24,0,0,1-4,8.57" />
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M16.53,6.94a6.93,6.93,0,0,1,0,10.48" />
                            </g>
                            <g>
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M4.71,3.57A11.21,11.21,0,0,0,1,9.83a10.82,10.82,0,0,0-.25,2.34,11.24,11.24,0,0,0,4,8.57" />
                                <path class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M7.47,6.94a6.93,6.93,0,0,0,0,10.48" />
                            </g>
                            <circle cx="12.13" cy="12.16" r="1.37" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[178]?.title || 'Manage Radio Station'} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="radio-station" className={`collapse p-0 mt-2 list-unstyled ${radioStationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}`} >
                {radioStationURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        <NavLink
                            to={data?.url}
                            className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                        >
                            <MessageBox text={data?.message} classname="ms-2 text-break" />
                        </NavLink>
                    </li>
                ))}
            </ul>
        </li>
    );

    const PlayoutManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[172]?.title} crown={!onlyPermission?.includes(29)} classname='sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            <div className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative mb-2 px-3  ${(window.location.pathname.startsWith('/tv-playouts') || window.location.pathname.startsWith('/edit/tv-playouts') || window.location.pathname.startsWith('/playout-logs')) && 'headingActive'}`} data-bs-toggle={"collapse"} data-bs-target={"#Playout-Management"} aria-expanded="false" aria-controls="Playout-Management">
                <div>
                    <img src={slider_01} alt="flogo" />
                    <MessageBox text={'Playout'} classname="ms-2 text-break" premium={!onlyPermission?.includes(29)} />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Playout-Management" className={`collapse p-0 mt-2 list-unstyled  ${(window.location.pathname.startsWith('/tv-playouts') || window.location.pathname.startsWith('/edit/tv-playouts') || window.location.pathname.startsWith('/playout-logs')) && 'show'}`}>
                <li className="mb-2">
                    {onlyPermission?.includes(29) ? (
                        <>
                            <NavLink className="d-flex align-items-center sideMenu  px-3  position-relative" to={"/tv-playouts"}>
                                <MessageBox text={labelDisplay?.[173]?.title} classname="ms-2 text-break" />
                            </NavLink>
                            <NavLink className="d-flex align-items-center sideMenu  px-3  position-relative" to={"/playout-logs"}>
                                <MessageBox text={"Playout Logs"} classname="ms-2 text-break" />
                            </NavLink>
                        </>
                    ) : (
                        <CustomTooltip {...tooltipConfig} >
                            <MessageBox text={labelDisplay?.[173]?.title} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                        </CustomTooltip>
                    )}
                </li>
            </ul>
        </li>
    );

    const AudioManagementMenu = () => (
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[29]?.title} classname='text-start sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(6)} />
            <div className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative mb-2 px-3  ${audioURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle={"collapse"} data-bs-target={"#Audio-Management"} aria-expanded="false" aria-controls="Audio-Management">
                <div>
                    <IconMyAudio />
                    <MessageBox text={labelDisplay?.[30]?.title} classname="ms-2 text-break" premium={!onlyPermission?.includes(6)} />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Audio-Management" className={`collapse p-0 mt-2 list-unstyled  ${(window.location.pathname.startsWith('/audio-lists') || window.location.pathname.startsWith('/add-audio') || window.location.pathname.startsWith('/audio-categories') || window.location.pathname.startsWith('/manage-albums')) && 'show'}`}>
                {audioURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className=" mb-2">
                        {onlyPermission?.includes(6) ? (
                            <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>
                ))}
            </ul>
        </li>
    );

    const ArtistManagementMenu = () => (
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[157]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(7)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative px-3  ${artistURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle={"collapse"} data-bs-target={"#Artist-Management"} aria-expanded="false" aria-controls="Artist-Management">
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <circle class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeWidth: "0.75px", stroke: "currentColor" }} cx="3.93" cy="20.22" r="2.93" />
                            <circle class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeWidth: "0.75px", stroke: "currentColor" }} cx="20.07" cy="17.29" r="2.93" />
                            <polyline class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeWidth: "0.75px", stroke: "currentColor" }} points="6.87 20.22 6.87 1.16 23 1.16 23 17.29" />
                            <line class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="6.87" y1="5.56" x2="23" y2="5.56" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[38]?.title} classname="ms-2 text-break" premium={!onlyPermission?.includes(7)} />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Artist-Management" className={`collapse p-0 mt-2 list-unstyled ${(window.location.pathname.startsWith('/add-artist') || window.location.pathname.startsWith('/all-artist')) && 'show'}`}>
                {artistURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className=" mb-2">
                        {onlyPermission?.includes(7) ? (
                            <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>
                ))}
            </ul>
        </li>
    );

    const ImageOrientationManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text="Image Orientation" classname='text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block' crown={!onlyPermission?.includes(41)} />

            <div id="imageOrientationManagement" className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 mb-2 ${(window.location.pathname.startsWith('/orientation-list') || window.location.pathname.startsWith('/add-orientation') || window.location.pathname.startsWith('/edit-orientation') || window.location.pathname.startsWith('/device-crop-rules') || window.location.pathname.startsWith('/add-device-crop-rule') || window.location.pathname.startsWith('/edit-device-crop-rule')) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Image-Orientation-Management" aria-expanded="false" aria-controls="Image-Orientation-Management">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <rect x="2" y="3" width="20" height="18" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.25" />
                            <path d="M8 3v18M16 3v18M2 9h20M2 15h20" stroke="currentColor" strokeWidth="1.25" fill="none" strokeLinecap="round" />
                            <circle cx="6" cy="6" r="1" fill="currentColor" />
                            <circle cx="18" cy="6" r="1" fill="currentColor" />
                            <circle cx="6" cy="18" r="1" fill="currentColor" />
                            <circle cx="18" cy="18" r="1" fill="currentColor" />
                        </g>
                    </svg>
                    <MessageBox text="Image Orientation" classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Image-Orientation-Management" className={`collapse p-0 mt-2 list-unstyled ${(window.location.pathname.startsWith('/orientation-list') || window.location.pathname.startsWith('/add-orientation') || window.location.pathname.startsWith('/edit-orientation') || window.location.pathname.startsWith('/device-crop-rules') || window.location.pathname.startsWith('/add-device-crop-rule') || window.location.pathname.startsWith('/edit-device-crop-rule')) && 'show'}`}>
                {imageOrientationURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className=" mb-2">
                        {onlyPermission?.includes(41) ? (
                            <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>
                ))}
            </ul>
        </li>
    );

    const UsersManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[43]?.title} classname='text-start sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(8)} />
            <div className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative mb-2 px-3  ${userURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#User" aria-expanded="false" aria-controls="User"  >
                <div>
                    <img src={user_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[44]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>

            <ul id="User" className={`collapse p-0 mt-2 list-unstyled ${userURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {userURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className=" mb-2">
                        {onlyPermission?.includes(8) ? (
                            <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>
                ))}
            </ul>
        </li>

    );

    const MenusManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text="Menu Management" classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(21)} />
            <div className={`nav-link  d-flex align-items-center justify-content-between  sideMenu position-relative px-3  ${menuURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Menu" aria-expanded="false" aria-controls="Menu">
                <div>
                    <img src={Menu_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[49]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Menu" className={`collapse p-0 mt-2 list-unstyled ${menuURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {menuURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(21) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const CustomFieldsManagementMenu = () => (
        Number(role) !== 4 &&
        !customFieldsEnabled &&
        <li className="nav-item mb-4">
            <MessageBox text={'Custom Fields'} classname='sideBarHeading d-block w-100 theme-text-color px-3 pb-2 text-start d-block' />
            <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 mb-2 ${window.location.pathname.startsWith('/custom-fields') && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Custom-Fields" aria-expanded="false" aria-controls="Custom-Fields">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M3 5h18v2H3V5zm0 6h12v2H3v-2zm0 6h18v2H3v-2z" />
                    </svg>
                    <MessageBox text={'Manage'} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Custom-Fields" className={`collapse p-0 mt-2 list-unstyled ${window.location.pathname.startsWith('/custom-fields') && 'show'}`}>
                <li className="mb-2">
                    <NavLink to="/custom-fields/dashboard" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                        <MessageBox text={'Dashboard'} classname="ms-2 text-break" />
                    </NavLink>
                </li>
                <li className="mb-2">
                    <NavLink to="/custom-fields" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                        <MessageBox text={'Fields'} classname="ms-2 text-break" />
                    </NavLink>
                </li>
                <li className="mb-2">
                    <NavLink to="/custom-fields/create" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                        <MessageBox text={'Create Field'} classname="ms-2 text-break" />
                    </NavLink>
                </li>
                <li className="mb-2">
                    <NavLink to="/custom-fields/assign" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                        <MessageBox text={'Assign Fields'} classname="ms-2 text-break" />
                    </NavLink>
                </li>
                <li className="mb-2">
                    <NavLink to="/custom-fields/sets" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                        <MessageBox text={'Field Sets'} classname="ms-2 text-break" />
                    </NavLink>
                </li>
                <li className="mb-2">
                    <NavLink to="/custom-fields/conditions" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                        <MessageBox text={'Conditions'} classname="ms-2 text-break" />
                    </NavLink>
                </li>
            </ul>
        </li>
    );

    const RegistrationMenusManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[171]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(28)} />
            <div className={`nav-link  d-flex align-items-center justify-content-between  sideMenu position-relative px-3  ${menuURLRegistrationMenu.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#RegistrationMenu" aria-expanded="false" aria-controls="RegistrationMenu">
                <div>
                    <img src={Menu_01} alt="flogo" className="" />
                    <MessageBox text={`Registration ${labelDisplay?.[49]?.title}`} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="RegistrationMenu" className={`collapse p-0 mt-2 list-unstyled ${menuURLRegistrationMenu.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {menuURLRegistrationMenu?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(28) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const LanguageManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[55]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(9)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${languageURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Language" aria-expanded="false" aria-controls="Language">
                <div>
                    <img src={Language_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[56]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Language" className={`collapse p-0 mt-2 list-unstyled ${languageURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}  `}>
                {languageURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(9) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const RegionManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={'Region Management'} classname='text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block' crown={!onlyPermission?.includes(47)} />
            <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 ${regionURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Region" aria-expanded="false" aria-controls="Region">
                <div>
                    <img src={Language_01} alt="flogo" className="" />
                    <MessageBox text={'Manage Region'} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Region" className={`collapse p-0 mt-2 list-unstyled ${regionURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}`}>
                {regionURL?.sort((a, b) => a.message.localeCompare(b.message))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(47) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig}>
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const TranslationManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={`${labelDisplay?.[194]?.title || 'Translation Management'}`} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(9)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${translationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Translation" aria-expanded="false" aria-controls="Translation">
                <div>
                    <img src={Language_01} alt="flogo" className="" />
                    <MessageBox text={`${labelDisplay?.[195]?.title || 'Manage Translation'}`} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Translation" className={`collapse p-0 mt-2 list-unstyled ${translationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}  `}>
                {translationURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(9) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const AdsBannerManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[61]?.title} classname='  sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' crown={!onlyPermission?.includes(10)} />
            {onlyPermission?.includes(10) ? (
                <NavLink className="d-flex align-items-center sideMenu  px-3  position-relative" to={"/sliders"}>
                    <img src={slider_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[62]?.title} classname="ms-2 text-break" />
                </NavLink>
            ) : (
                <CustomTooltip {...tooltipConfig} >
                    <div className="d-flex ms-3">
                        <img src={slider_01} alt="flogo" className="" />
                        <MessageBox text={labelDisplay?.[62]?.title} classname="d-flex align-items-center sideMenu position-relative" role="button" />
                    </div>
                </CustomTooltip>
            )}
        </li>
    );

    const PlayerManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[63]?.title} classname='  sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' crown={!onlyPermission?.includes(11)} />
            <div id="playerManagement" className={`nav-link  d-flex align-items-center justify-content-between sideMenu position-relative  px-3  mb-2 ${(window.location.pathname.startsWith('/music-settings') || window.location.pathname.startsWith('/players')) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#player-Management" aria-expanded="false" aria-controls="player-Management"  >
                <div>
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g>
                            <rect class="cls-1" style={{ fill: "none", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x="1" y="3.16" width="22.01" height="12.89" rx="0.94" /> <g>
                                <line class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="22.78" y1="20.82" x2="13.33" y2="20.82" />
                                <line class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} x1="10.67" y1="20.82" x2="1.22" y2="20.82" />
                                <path class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M13.33,20.82a1.33,1.33,0,1,0-2.66,0" />
                                <path class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} d="M10.67,20.82a1.33,1.33,0,1,0,2.66,0" />
                            </g>
                            <polygon class="cls-1" style={{ fill: "currentcolor", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "0.75px", stroke: "currentColor" }} points="9.9 12.2 9.9 6.54 14.1 9.37 9.9 12.2" />
                        </g>
                    </svg>
                    <MessageBox text={labelDisplay?.[63]?.title} classname="ms-2 text-break" />
                </div>

                <IoIosArrowDown />
            </div>
            <ul id="player-Management" className={`collapse p-0 mt-2 list-unstyled ${(window.location.pathname.startsWith('/players') || window.location.pathname.startsWith('/music-settings')) && 'show'}`} >
                {playerUrl?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(11) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const PartnerManagementMenu = () => {
        const isPartner = Number(role) === 4;
        const currentPath = window.location.pathname;
        const isAnalyticActive = isPartner ? PartnerAnalyticsURL.some(p => currentPath.startsWith(p.url)) : (currentPath.startsWith('/partner-analytics') || PartnerURL.some(p => currentPath.startsWith(p.url)) || PartnerPayout.some(p => currentPath.startsWith(p.url)));

        return (
            <li className="nav-item mb-4" >
                <MessageBox text={labelDisplay?.[66]?.title || 'Partner Management'} crown={!isPartner && !onlyPermission?.includes(12)} classname='text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block' />
                <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative mb-2 px-3 ${isAnalyticActive && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#PartnerDropdown" aria-expanded="false" aria-controls="PartnerDropdown">
                    <div>
                        <img src={content_partner_01} alt="flogo" className="" />
                        <MessageBox text={'Partner'} classname="ms-2 text-break" />
                    </div>
                    <IoIosArrowDown />
                </div>
                <ul id="PartnerDropdown" className={`collapse p-0 mt-2 list-unstyled ${isAnalyticActive && 'show'}`} >
                    {isPartner ? (
                        PartnerAnalyticsURL?.map((data, index) => (
                            <li className="mb-2" key={index}>
                                <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                    <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                                </NavLink>
                            </li>
                        ))
                    ) : (
                        <>

                            {PartnerURL?.map((data, index) => (
                                <li className="mb-2" key={`mgmt-${index}`}>
                                    {onlyPermission?.includes(12) ? (
                                        <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                            <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                                        </NavLink>
                                    ) : (
                                        <CustomTooltip {...tooltipConfig} >
                                            <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                                        </CustomTooltip>
                                    )}
                                </li>
                            ))}

                            <li className="mb-2">
                                {onlyPermission?.includes(12) ? (
                                    <NavLink to="/partner-analytics" className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                        <MessageBox text="Partner Analytics" classname="ms-2 text-break" />
                                    </NavLink>
                                ) : (
                                    <CustomTooltip {...tooltipConfig} >
                                        <MessageBox text="Partner Analytics" classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                                    </CustomTooltip>
                                )}
                            </li>

                        </>
                    )}
                </ul>
            </li>
        );
    };

    const PageManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[82]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(13)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${pagesURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Pages" aria-expanded="false" aria-controls="Pages">
                <div>
                    <img src={Pages_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[83]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Pages" className={`collapse p-0 mt-2 list-unstyled ${pagesURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {pagesURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(13) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const PlansManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[87]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(14)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${plansURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Plans" aria-expanded="false" aria-controls="Plans">
                <div>
                    <img src={plans_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[88]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Plans" className={`collapse p-0 mt-2 list-unstyled ${plansURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {plansURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(14) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const PaymentManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[93]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(15)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${paymentURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Payment-Management" aria-expanded="false" aria-controls="Payment-Management">
                <div>
                    <img src={Payment_Management_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[94]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Payment-Management" className={`collapse p-0 mt-2 list-unstyled ${paymentURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {paymentURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(15) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const AnalyticsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[98]?.title} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(16)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${analyticsURL?.some((path) => window.location.pathname.startsWith(path?.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Analytics" aria-expanded="false" aria-controls="Analytics">
                <div>
                    <img src={analytics_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[99]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Analytics" className={`collapse p-0 mt-2 list-unstyled ${analyticsURL?.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {analyticsURL?.slice(0, 4)?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(16) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative px-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>

    );

    const DonationManagementMenu = () => (
        Number(role) !== 4 && Number(siteTheme?.enable_donate) === 1 &&
        <li className="nav-item mb-4">
            <MessageBox text={"Donation Management"} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(42)} />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${donationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Donation-Management" aria-expanded="false" aria-controls="Donation-Management">
                <div>
                    <img src={Payment_Management_01} alt="flogo" className="" />
                    <MessageBox text={"Donation Management"} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Donation-Management" className={`collapse p-0 mt-2 list-unstyled ${donationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `}>
                {donationURL?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(42) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );


    const PushNotificationManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={"Push Notification"} classname='text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block' crown={!onlyPermission?.includes(44)} />
            <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 ${pushNotificationURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#PushNotification-Management" aria-expanded="false" aria-controls="PushNotification-Management">
                <div>
                    <img src={Settings_01} alt="flogo" className="" />
                    <MessageBox text={"Push Notifications"} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="PushNotification-Management" className={`collapse p-0 mt-2 list-unstyled ${pushNotificationURL.some((path) => window.location.pathname.pathname === path.url) && 'show'}`}>
                {pushNotificationURL?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(44) ? (
                            <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3">
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const ImportExportManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[779]?.title || 'Bulk Data Import'} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' crown={!onlyPermission?.includes(35)} />
            <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 mb-2 ${importExportURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#ImportExport" aria-expanded="false" aria-controls="ImportExport">
                <div>
                    <img src={add_list_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[781]?.title || 'Import/Exports'} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="ImportExport" className={`collapse p-0 mt-2 list-unstyled ${importExportURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}`}>
                {importExportURL?.map((data, index) => (
                    <li key={index} className="mb-2">
                        {onlyPermission?.includes(35) ? (
                            <NavLink
                                to={`${data?.url}`}
                                className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"
                            >
                                <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                            </NavLink>
                        ) : (
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        )}
                    </li>
                ))}
            </ul>
        </li>
    );

    const StoreFrontSettingsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[153]?.title} crown={!onlyPermission?.includes(22)} classname='sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            {onlyPermission?.includes(22) ?
                <NavLink className="d-flex align-items-center sideMenu mb-2 px-3  position-relative" to={"/settings"}>
                    <img src={Settings_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[105]?.title} classname="ms-2 text-break" />
                </NavLink>
                :
                <CustomTooltip {...tooltipConfig} >
                    <div className="d-flex ms-3">
                        <img src={Settings_01} alt="flogo" className="" />
                        <MessageBox text={labelDisplay?.[105]?.title} classname="d-flex align-items-center sideMenu position-relative" role="button" />
                    </div>
                </CustomTooltip>
            }
        </li>
    );

    const MainSettingsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[103]?.title} crown={!onlyPermission?.includes(17)} classname="text-start sideBarHeading d-block w-100 theme-text-color px-3 pb-2 d-block" />
            <div className={`nav-link d-flex align-items-center justify-content-between sideMenu position-relative px-3 ${settingsURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#Settings" aria-expanded="false" aria-controls="Settings"                            >
                <div>
                    <img src={Settings_01} alt="flogo" />
                    <MessageBox text={labelDisplay?.[104]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="Settings" className={`collapse p-0 mt-2 list-unstyled ${settingsURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'}`}                            >
                {settingsURL?.filter((data) => !(data?.url === '/dsp-settings'))?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data) => (
                    <li key={data?.url} className="mb-2">
                        {onlyPermission?.includes(17) ? (<NavLink to={data?.url} className="d-flex align-items-center sideMenu position-relative px-3"                                        >
                            <MessageBox text={data?.message} classname="ms-2 text-break" />
                        </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>
                ))}

            </ul>
        </li>
    );

    const HomePageSettingsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4" >
            <MessageBox text={labelDisplay?.[151]?.title} crown={!onlyPermission?.includes(23)} classname='text-start sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${settingsURLhome.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#settingsURLhome" aria-expanded="false" aria-controls="settingsURLhome"  >
                <div>
                    <img src={Settings_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[154]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="settingsURLhome" className={`collapse p-0 mt-2 list-unstyled ${settingsURLhome.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `} >
                {settingsURLhome
                    ?.filter((data) => !(data?.url === '/dsp-settings'))
                    ?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))
                    ?.map((data) => (
                        <li key={data?.url} className="mb-2">
                            {onlyPermission?.includes(23) ? (<NavLink to={data?.url} className="d-flex align-items-center sideMenu position-relative px-3">
                                <MessageBox text={data?.message} classname="ms-2 text-break" />
                            </NavLink>) :
                                <CustomTooltip {...tooltipConfig} >
                                    <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                                </CustomTooltip>
                            }
                        </li>
                    ))}
            </ul>
        </li>
    );

    const AppSettingsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4" >
            <MessageBox text={labelDisplay?.[152]?.title} crown={!onlyPermission?.includes(24)} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' />
            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${settingsURLApp.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#settingsURLApp" aria-expanded="false" aria-controls="settingsURLApp"  >
                <div>
                    <img src={Settings_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[155]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="settingsURLApp" className={`collapse p-0 mt-2 list-unstyled ${settingsURLApp.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `} >
                {settingsURLApp?.filter((data) => !(data?.url === '/dsp-settings'))?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data) => (
                    <li key={data?.url} className="mb-2">
                        {onlyPermission?.includes(24) ? (<NavLink to={data?.url} className="d-flex align-items-center sideMenu position-relative px-3">
                            <MessageBox text={data?.message} classname="ms-2 text-break" />
                        </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>
                ))}
            </ul>
        </li>
    );

    const SEOSettingsManagementMenu = () => (
        Number(role) !== 4 &&
        <div className="mb-4">
            <MessageBox text={labelDisplay?.[144]?.title} crown={!onlyPermission?.includes(25)} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' />

            <li className="nav-item mt-2">
                {onlyPermission?.includes(25) ? (
                    <NavLink to={"/site-meta-settings"} className="d-flex align-items-center sideMenu  px-3  position-relative"  >
                        <img src={Settings_01} alt="flogo" className="" />
                        <MessageBox text={labelDisplay?.[125]?.title} classname="ms-2 text-break" />
                    </NavLink>
                ) :
                    <CustomTooltip {...tooltipConfig} >
                        <MessageBox text={labelDisplay?.[125]?.title} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                    </CustomTooltip>
                }
            </li>
            <li className="nav-item mt-2">
                {onlyPermission?.includes(25) ? (
                    <NavLink to={"/linking_settings"} className="d-flex align-items-center sideMenu  px-3  position-relative"  >
                        <img src={Settings_01} alt="flogo" className="" />
                        <MessageBox text={labelDisplay?.[110]?.title} classname="ms-2 text-break" />
                    </NavLink>
                ) :
                    <CustomTooltip {...tooltipConfig} >
                        <MessageBox text={labelDisplay?.[110]?.title} classname="d-flex align-items-center sideMenu position-relative ms-3" role="button" />
                    </CustomTooltip>
                }
            </li>

            <div className={`nav-link  d-flex align-items-center  justify-content-between sideMenu position-relative  px-3  ${faqURL.some((path) => window.location.pathname.startsWith(path.url)) && 'headingActive'}`} data-bs-toggle="collapse" data-bs-target="#faq-Management" aria-expanded="false" aria-controls="Ads-Management"  >
                <div>
                    <img src={See_Log_Activity_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[145]?.title} classname="ms-2 text-break" />
                </div>
                <IoIosArrowDown />
            </div>
            <ul id="faq-Management" className={`collapse p-0 mt-2 list-unstyled ${faqURL.some((path) => window.location.pathname.startsWith(path.url)) && 'show'} `} >
                {faqURL?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) =>
                    <li className=" mb-2" >
                        {onlyPermission?.includes(25) ? (<NavLink to={data?.url} className="d-flex align-items-center sideMenu position-relative px-3">
                            <MessageBox text={data?.message} classname="ms-2 text-break" />
                        </NavLink>) :
                            <CustomTooltip {...tooltipConfig} >
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative ms-5" role="button" tabIndex={0} />
                            </CustomTooltip>
                        }
                    </li>)}
            </ul>
        </div>
    );

    const AdvertiserManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4" >
            <MessageBox text={labelDisplay?.[130]?.title} crown={!onlyPermission.includes(18)} classname='text-start   sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 d-block' />
            {advertiserMenuUrls?.sort((a, b) => (a.message || "").localeCompare(b.message || ""))?.map((data, index) => (
                <li key={index} className="mb-2">
                    {onlyPermission?.includes(18) ? (
                        <NavLink to={`${data?.url}`} className="d-flex align-items-center sideMenu position-relative ps-4 pe-3"                        >
                            <img src={data?.image} alt="flogo" className="" />
                            <MessageBox text={`${data?.message}`} classname="ms-2 text-break" />
                        </NavLink>
                    ) : (
                        <CustomTooltip {...tooltipConfig} >
                            <div className="d-flex ms-3">
                                <img src={data?.image} alt="flogo" className="" />
                                <MessageBox text={`${data?.message}`} classname="d-flex align-items-center sideMenu position-relative" role="button" tabIndex={0} />
                            </div>
                        </CustomTooltip>
                    )}
                </li>
            ))}
        </li>
    );

    const ContactManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[140]?.title} crown={!onlyPermission?.includes(19)} classname='  sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            {onlyPermission?.includes(19) ?
                <NavLink className="d-flex align-items-center sideMenu mb-2 px-3  position-relative" to={"/contact-us"}>
                    <img src={contact_request} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[141]?.title} classname="ms-2 text-break" />
                </NavLink>
                :
                <CustomTooltip {...tooltipConfig} >
                    <div className="d-flex ms-3">
                        <img src={contact_request} alt="flogo" className="" />
                        <MessageBox text={labelDisplay?.[141]?.title} classname="d-flex align-items-center sideMenu position-relative" role="button" tabIndex={0} />
                    </div>
                </CustomTooltip>
            }
        </li>
    );

    const SSAIAdsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={"SSAI Ads Management"} crown={!onlyPermission?.includes(44)} classname='  sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            {onlyPermission?.includes(44) ?
                <NavLink className="d-flex align-items-center sideMenu mb-2 px-3  position-relative" to={"/ssai-settings"}>
                    <img src={Ads_Compaigns_01} alt="flogo" className="" />
                    <MessageBox text={"SSAI Settings"} classname="ms-2 text-break" />
                </NavLink>
                :
                <CustomTooltip {...tooltipConfig} >
                    <div className="d-flex ms-3">
                        <img src={Ads_Compaigns_01} alt="flogo" className="" />
                        <MessageBox text={"SSAI Settings"} classname="d-flex align-items-center sideMenu position-relative" role="button" tabIndex={0} />
                    </div>
                </CustomTooltip>
            }
        </li>
    );

    const LogsManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={labelDisplay?.[142]?.title} crown={!onlyPermission?.includes(20)} classname='sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            {onlyPermission?.includes(20) ?
                <NavLink className="d-flex align-items-center sideMenu mb-2 px-3  position-relative" to={"/logActivity"}>
                    <img src={See_Log_Activity_01} alt="flogo" className="" />
                    <MessageBox text={labelDisplay?.[143]?.title} classname="ms-2 text-break" />
                </NavLink>
                :
                <CustomTooltip {...tooltipConfig} >
                    <div className="d-flex ms-3">
                        <img src={See_Log_Activity_01} alt="flogo" className="" />
                        <MessageBox text={labelDisplay?.[143]?.title} classname="d-flex align-items-center sideMenu position-relative" role="button" tabIndex={0} />
                    </div>
                </CustomTooltip>
            }
        </li>
    );

    const PurchaseManagementMenu = () => (
        Number(role) !== 4 &&
        <li className="nav-item mb-4">
            <MessageBox text={"Subscription Management"} classname='  sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            <NavLink className="d-flex align-items-center sideMenu mb-2 px-3  position-relative" to={"/purchase-subscription"}>
                <img src={Payment_Management_01} alt="flogo" className="" />
                <MessageBox text={"Purchase Subscription"} classname="ms-2 text-break" />
            </NavLink>
        </li>
    )

    const EmailSettingsManagementMenu = () => (
        adminSetting?.productType !== 'full_package' && Number(role) !== 5 && !onlyPermission?.includes(17) &&
        <li className="nav-item mb-4">
            <MessageBox text={"Email Management"} classname='  sideBarHeading d-block w-100 theme-text-color  px-3 pb-2 text-start d-block' />
            <NavLink className="d-flex align-items-center sideMenu mb-2 px-3  position-relative" to={"/email_settings"}>
                <img src={Email_Settings} alt="flogo" className="" />
                <MessageBox text={"Email Settings"} classname="ms-2 text-break" />
            </NavLink>
        </li>
    )

    const allMenus = [
        { id: 1, component: <DashboardManagementMenu /> },
        { id: 36, component: <SuperAdminManagementMenu /> },
        { id: 26, component: <RolesAndPermissionManagementMenu /> },
        { id: 27, component: <LibraryManagementMenu /> },
        { id: 3, component: <VideoManagementMenu /> },
        { id: 39, component: <UGCManagementMenu /> },
        { id: 4, component: <SeriesManagementMenu /> },
        { id: 5, component: <LiveStreamManagementMenu /> },
        { id: 40, component: <RadioStationManagementMenu /> },
        { id: 29, component: <PlayoutManagementMenu /> },
        { id: 6, component: <AudioManagementMenu /> },
        { id: 7, component: <ArtistManagementMenu /> },
        { id: 41, component: <ImageOrientationManagementMenu /> },
        { id: 8, component: <UsersManagementMenu /> },
        { id: 21, component: <MenusManagementMenu /> },
        { id: 37, component: <CustomFieldsManagementMenu /> },
        { id: 28, component: <RegistrationMenusManagementMenu /> },
        { id: 9, component: <LanguageManagementMenu /> },
        { id: 47, component: <RegionManagementMenu /> },
        { id: 38, component: <TranslationManagementMenu /> },
        { id: 10, component: <AdsBannerManagementMenu /> },
        { id: 11, component: <PlayerManagementMenu /> },
        { id: Number(role) === 4 ? null : 12, component: <PartnerManagementMenu /> },
        { id: 13, component: <PageManagementMenu /> },
        { id: 14, component: <PlansManagementMenu /> },
        { id: 15, component: <PaymentManagementMenu /> },
        { id: 16, component: <AnalyticsManagementMenu /> },
        { id: 35, component: <ImportExportManagementMenu /> },
        { id: 22, component: <StoreFrontSettingsManagementMenu /> },
        { id: 17, component: <MainSettingsManagementMenu /> },
        { id: 23, component: <HomePageSettingsManagementMenu /> },
        { id: 24, component: <AppSettingsManagementMenu /> },
        { id: 25, component: <SEOSettingsManagementMenu /> },
        { id: 18, component: <AdvertiserManagementMenu /> },
        { id: 19, component: <ContactManagementMenu /> },
        { id: 20, component: <LogsManagementMenu /> },
        { id: 44, component: <SSAIAdsManagementMenu /> },
        { id: 42, component: <DonationManagementMenu /> },
        { id: 44, component: <PushNotificationManagementMenu /> },
        { component: <PurchaseManagementMenu /> },
    ];

    const productBasedMenus = [
        { component: <EmailSettingsManagementMenu /> }
    ];

    const permittedMenus = useMemo(() => {
        return allMenus.filter(m => !m.id || onlyPermission?.includes(m.id));
    }, [onlyPermission, labelDisplay, superAdminURL, artistURL, audioURL, faqURL, liveURL, userURL, menuURL, menuURLRegistrationMenu, videoURL, seriesURL, languageURL, contentPartnerURL, channelPartnerURL, pagesURL, plansURL, paymentURL, donationURL, analyticsURL, settingsURL, settingsURLhome, settingsURLApp, PartnerURL, RolesURL, PartnerPayout, LibraryURL, radioStationURL, importExportURL, Partner_payoutURL, playerUrl, translationURL, partnerSettingsURL, imageOrientationURL, advertiserMenuUrls, pushNotificationURL, PartnerAnalyticsURL]);

    const restrictedMenus = useMemo(() => {
        return allMenus.filter(m => m.id && !onlyPermission?.includes(m.id));
    }, [onlyPermission, labelDisplay, superAdminURL, artistURL, audioURL, faqURL, liveURL, userURL, menuURL, menuURLRegistrationMenu, videoURL, seriesURL, languageURL, contentPartnerURL, channelPartnerURL, pagesURL, plansURL, paymentURL, donationURL, analyticsURL, settingsURL, settingsURLhome, settingsURLApp, PartnerURL, RolesURL, PartnerPayout, LibraryURL, radioStationURL, importExportURL, Partner_payoutURL, playerUrl, translationURL, partnerSettingsURL, imageOrientationURL, advertiserMenuUrls, pushNotificationURL, PartnerAnalyticsURL]);

    const { showBanner: timeBanner } = getBannerInfo();
    const maintenanceEnabled = Number(siteTheme?.maintenance_banner_enabled) === 1;
    const showBanner = maintenanceEnabled && timeBanner;


    return (
        <section className="sidebarMenu ">
            <div className={`adminSideBarLeft  ${toggleClassName ? "active" : ""} theme-bg-color ${isSubscriptionExpired ? "expired" : ""}`} onClickCapture={handleBlockedNav} onKeyDownCapture={handleKeyBlock} aria-disabled={isSubscriptionExpired ? "true" : undefined} >
                <NavLink className={`sideBarBrand d-lg-block px-2 px-lg-0 text-center d-flex align-items-center theme-bg-color ${showBanner ? "mt-4" : ""}`} to={"/"} >
                    {siteTheme?.light_mode_logo === null ? <Defaultloadinggif /> : <img src={siteTheme?.light_mode_logo} alt="flogo" className="mx-auto d-block py-3 object-fit-contain" style={{ width: "200px", height: "80px" }} loading="lazy" />}
                    <IoMdClose onClick={() => toggleAction()} className="d-lg-none" style={{ width: "20px", height: "20px", fill: "#000" }} />
                </NavLink>

                {loading && (<Response_Processing></Response_Processing>)}

                <ul className="list-unstyled px-2">
                    {permittedMenus.map((m, i) => <React.Fragment key={`allowed-${i}`}>{m.component}</React.Fragment>)}
                    {/* {productBasedMenus.map((m, i) => (<React.Fragment key={`product-${i}`}>{m.component}</React.Fragment>))} */}
                    {/* {restrictedMenus.map((m, i) => <React.Fragment key={`restricted-${i}`}>{m.component}</React.Fragment>)} */}
                </ul>

            </div>
        </section>
    );
}

const mapStateToProps = state => ({
    labelDisplay: state.sideBar.labelDisplay,
    onlyPermission: state.userPermission.onlyPermission,
    siteTheme: state.siteTheme.siteTheme,
    adminSetting: state.siteTheme.adminSetting,
    loading: state.siteTheme.loading,
});
export default connect(mapStateToProps)(React.memo(Sidebar))
